var _rect, _rect2, _g, _rect3, _rect4, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIllustration(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 73,
    viewBox: "0 0 85 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 30.3584,
    width: 84.15,
    height: 42.075,
    fill: "url(#paint0_linear_2347_21961)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2347_21961",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 30,
    width: 85,
    height: 43
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 30.3584,
    width: 84.15,
    height: 42.075,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2347_21961)"
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 33.6602,
    y: 89.7617,
    width: 96.7974,
    height: 23.3031,
    transform: "rotate(-30 33.6602 89.7617)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3108 49.4077C44.7746 49.4077 44.3398 48.973 44.3398 48.4368C44.3398 47.9005 44.7746 47.4658 45.3108 47.4658H63.3429C63.8792 47.4658 64.3139 47.9005 64.3139 48.4368C64.3139 48.973 63.8792 49.4077 63.3429 49.4077H45.3108Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 30.3584H23.9504V73.0807H0V30.3584Z",
    fill: "#001D4B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-14.3281 71.1387C-14.3281 80.0762 -7.08289 87.3214 1.85457 87.3214C10.792 87.3214 18.0373 80.0762 18.0373 71.1387C18.0373 62.2013 10.792 54.9561 1.85457 54.9561C-7.08289 54.9561 -14.3281 62.2013 -14.3281 71.1387ZM11.5642 71.1387C11.5642 76.5012 7.21704 80.8484 1.85457 80.8484C-3.50791 80.8484 -7.85505 76.5012 -7.85505 71.1387C-7.85505 65.7763 -3.50791 61.4291 1.85457 61.4291C7.21704 61.4291 11.5642 65.7763 11.5642 71.1387Z",
    fill: "#E0987C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 38.9466V38.1816H84.15V38.9466H0Z",
    fill: "#D33234"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 11.9004,
    width: 60.9396,
    height: 30.4698,
    fill: "url(#paint1_linear_2347_21961)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2347_21961",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 0,
    width: 62,
    height: 31
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 11.9004,
    width: 60.9396,
    height: 30.4698,
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2347_21961)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.0625 15.0453H59.7252",
    stroke: "#0069D5",
    strokeWidth: 1.95319,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9004 0H29.8958V30.9385H11.9004V0Z",
    fill: "#001D4B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3275 24.0242C17.0467 24.0242 17.6296 23.4412 17.6296 22.722C17.6296 22.0029 17.0467 21.4199 16.3275 21.4199C15.6084 21.4199 15.0254 22.0029 15.0254 22.722C15.0254 23.4412 15.6084 24.0242 16.3275 24.0242ZM16.3275 27.9306C17.0467 27.9306 17.6296 27.3476 17.6296 26.6284C17.6296 25.9093 17.0467 25.3263 16.3275 25.3263C15.6084 25.3263 15.0254 25.9093 15.0254 26.6284C15.0254 27.3476 15.6084 27.9306 16.3275 27.9306ZM20.885 27.9306C21.6041 27.9306 22.1871 27.3476 22.1871 26.6284C22.1871 25.9093 21.6041 25.3263 20.885 25.3263C20.1658 25.3263 19.5828 25.9093 19.5828 26.6284C19.5828 27.3476 20.1658 27.9306 20.885 27.9306ZM26.7445 26.6284C26.7445 27.3476 26.1616 27.9306 25.4424 27.9306C24.7233 27.9306 24.1403 27.3476 24.1403 26.6284C24.1403 25.9093 24.7233 25.3263 25.4424 25.3263C26.1616 25.3263 26.7445 25.9093 26.7445 26.6284ZM22.1871 22.722C22.1871 23.4412 21.6041 24.0242 20.885 24.0242C20.1658 24.0242 19.5828 23.4412 19.5828 22.722C19.5828 22.0029 20.1658 21.4199 20.885 21.4199C21.6041 21.4199 22.1871 22.0029 22.1871 22.722ZM25.4424 24.0242C26.1616 24.0242 26.7445 23.4412 26.7445 22.722C26.7445 22.0029 26.1616 21.4199 25.4424 21.4199C24.7233 21.4199 24.1403 22.0029 24.1403 22.722C24.1403 23.4412 24.7233 24.0242 25.4424 24.0242Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9004 6.82196V6.36621H72.84V6.82196H11.9004Z",
    fill: "#0069D5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2347_21961",
    x1: 110.854,
    y1: 50.5189,
    x2: 57.9344,
    y2: -5.49614,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB966"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF895F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF895F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2347_21961",
    x1: 94.9662,
    y1: 21.6998,
    x2: 78.1606,
    y2: -12.1524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85D4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51A4FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustration);
export default __webpack_public_path__ + "static/media/illustration.5d10e275173bdbc17458599df18681fb.svg";
export { ForwardRef as ReactComponent };